import { ActionPlanStatus } from './actionPlan';

export interface SettingsType {
  frequency: string;
  isPaycheck: boolean;
  actionPlanStatus: ActionPlanStatus;
}

export const USER_SETTINGS = '_user_settings';
